// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1a4h2","label":"Labeled_label__hHU7A","divider":"Labeled_divider__2ZvUr"};